import React, { useEffect, useState } from "react";
import { ApiGet, ApiDelete } from "../../../helpers/API/ApiData";
import DataTable, { defaultThemes } from "react-data-table-component";
import DeleteIcon from "@material-ui/icons/Delete";
import { Button, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Activity.scss";
import Loader from "react-loader-spinner";

const Activity = () => {
  const [allLogs, setAllLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedLogId, setSelectedLogId] = useState(null);
  const [loaderHas, setLoaderHas] = useState(false);

  // Fetch logs
  useEffect(() => {
    getActivityLogs();
  }, []);

  const getActivityLogs = async () => {
    setLoading(true);
    try {
      const res = await ApiGet("user/log-activity"); // ✅ Your backend API endpoint
      const logs = res?.data?.payload || [];
      // Format logs for table
      const formatted = logs.map((log) => ({
        ...log,
        userName: log?.userId?.name || "N/A",
        userEmail: log?.userId?.email || "N/A",
        userType: log?.userId?.userType || "N/A",
      }));

      setAllLogs(formatted);
      setFilteredLogs(formatted);
    } catch (err) {
      console.error("Error fetching logs:", err);
      toast.error("Failed to fetch logs");
    }
    setLoading(false);
  };

  // Handle delete log
  const handleDelete = async () => {
    if (!selectedLogId) return;
    setLoaderHas(true);
    try {
      await ApiDelete(`activity-log/${selectedLogId}`);
      toast.success("Log deleted successfully");
      setAllLogs(allLogs.filter((log) => log._id !== selectedLogId));
      setFilteredLogs(filteredLogs.filter((log) => log._id !== selectedLogId));
      setShowDeleteModal(false);
    } catch (err) {
      console.error("Delete error:", err);
      toast.error("Failed to delete log");
    }
    setLoaderHas(false);
  };

  // Search filter
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setFilteredLogs(() =>
      allLogs.filter(
        (item) =>
          item?.userName?.toLowerCase().includes(value) ||
          item?.userEmail?.toLowerCase().includes(value) ||
          item?.action?.toLowerCase().includes(value) ||
          item?.entityType?.toLowerCase().includes(value)
      )
    );
  };

  // Date formatter
  const formatDate = (date) => {
    if (!date) return "N/A";
    const d = new Date(date);
    return d.toLocaleString();
  };

  // Table Columns
  const columns = [
    {
      name: "S.No.",
      cell: (row, index) => index + 1,
      width: "70px",
    },
    {
      name: "User Name",
      selector: "userName",
      sortable: true,
      wrap: true,
    },
    {
      name: "Email",
      selector: "userEmail",
      sortable: true,
      wrap: true,
    },
    // {
    //   name: "User Type",
    //   selector: "userType",
    //   sortable: true,
    // },
    {
      name: "Action",
      selector: "action",
      sortable: true,
    },
    // {
    //   name: "Entity",
    //   selector: "entityType",
    //   sortable: true,
    // },
    {
      name: "Description",
      selector: "description",
      sortable: true,
      wrap: true,
    },
    {
      name: "Date",
      cell: (row) => <>{formatDate(row.createdAt)}</>,
      sortable: true,
    },
    // {
    //   name: "Actions",
    //   cell: (row) => (
    //     <div
    //       className="cursor-pointer"
    //       onClick={() => {
    //         setSelectedLogId(row._id);
    //         setShowDeleteModal(true);
    //       }}
    //     >
    //       <DeleteIcon />
    //     </div>
    //   ),
    // },
  ];

  // Table styles
  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
      },
    },
    cells: {
      style: {
        fontSize: "13px",
      },
    },
  };

  return (
    <>
      <ToastContainer />
      <div className="card p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Activity Logs</h2>
          <input
            type="text"
            className="form-control w-50"
            placeholder="Search logs by name, email, action..."
            onChange={handleSearch}
          />
        </div>

        {/* <DataTable
          columns={columns}
          data={filteredLogs}
          customStyles={customStyles}
          progressPending={loading}
          pagination
          highlightOnHover
          dense
        /> */}


          <DataTable
                    columns={columns}
                    data={filteredLogs}
                    pagination
                    customStyles={customStyles}
                    // conditionalRowStyles={conditionalRowStyles}
                    style={{
                      marginTop: "-3rem",
                    }}
                    progressPending={loading}
                    progressComponent={
                      <Loader type="Puff" color="#334D52" height={30} width={30} />
                    }
                  />
      </div>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title className="text-danger">Delete Log</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this activity log?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button
            variant="danger"
            disabled={loaderHas}
            onClick={handleDelete}
          >
            Delete
            {loaderHas && <span className="mx-2 spinner spinner-white"></span>}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Activity;
